module.exports = __webpack_public_path__ + "img/50972ee.gif";